import { Box, useTheme } from "@material-ui/core";
import { assetIds, ThemedAsset } from "nemuru-components";
import React, { useContext, useEffect, useState } from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import IconTitle from "../../../../../shared/components/IconTitle";
import Text from "../../../../../shared/components/Text";
import MainButton from "../../../../../shared/components/MainButton";
import { RISK_ANALYSIS_OPTINS_TYPES_LIST } from "../../config";
import OptinsManager from "../../../../../shared/components/OptinsManager";
import { useForm } from "react-hook-form";
import {
  checkInitialStateForDisableAcceptButton,
  getModuleOptIns,
  isAnyOptInInNullState,
} from "../../../../../../utils/optInsHelpers";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";
import { OptInsPatchCheckMapper } from "../../../../../../utils/mappers/OptInsPatchMappers";
import { useActionCallback } from "../../../../../../utils/hooks/useActionCallback";
import { TermsAndConditionsContainer } from "../../../../../shared/components/TermsAndConditionsContainer";

export const RiskAnalysisOptIns = ({ setModuleNextStep }) => {
  const {
    state: { optIns, loan, participant },
    dispatch,
  } = useContext(ProcessContext);
  const { palette } = useTheme();
  const { handleSubmit, errors, register, control, setValue, getValues } =
    useForm();

  const [state, setState] = useState({
    optInsState: [],
  });
  const [disabled, setDisabled] = useState(true);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const { optInsState } = state;

  useEffect(() => {
    setDisabled(checkInitialStateForDisableAcceptButton(optInsState));
  }, []);

  useEffect(() => {
    checkWhichOptinsBelongToModuleAndSetState();
  }, [optIns]);

  const checkWhichOptinsBelongToModuleAndSetState = () => {
    const optInConditionsTempArray = getModuleOptIns(
      RISK_ANALYSIS_OPTINS_TYPES_LIST,
      optIns
    );
    setState((s) => ({
      ...s,
      optInsState: optInConditionsTempArray,
    }));
  };

  const handleToggleChange = (name, value) => {
    setValue(name, value);
    setDisabled(isAnyOptInInNullState(getValues()));
  };

  const handleRiskAnalysisOptIns = () => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
    submitConditionsConsents();
  };

  const submitConditionsConsents = () => {
    var conditions_check = [];
    var formValuesObject = getValues();
    Object.keys(formValuesObject).map((value) => {
      optInsState.map((optin) => {
        optin.name === value &&
          conditions_check.push({
            id: optin.condition_id,
            check: formValuesObject[value],
          });
      });
    });
    const dataToSend = OptInsPatchCheckMapper.hydrate({
      id: optIns.id,
      conditions_check,
      loanId: loan.id,
      borrowerId: participant.participantId,
    });

    dispatch({
      type: "REQUEST_PATCH_OPTIN_BY_ID_CONDITIONS_CHECK_IN",
      payload: dataToSend,
    });
  };

  useActionCallback(
    "REQUEST_PATCH_OPTIN_BY_ID_CONDITIONS_CHECK_IN_FULFILLED",
    () => {
      setModuleNextStep();
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
    }
  );

  useActionCallback(
    "REQUEST_PATCH_OPTIN_BY_ID_CONDITIONS_CHECK_IN_REJECTED",
    () => {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
    }
  );

  const onEndScroll = (isAtBottom) => {
    if (isAtBottom) {
      setIsAtBottom(true);
    }
  };

  return (
    <>
      <Box>
        <IconTitle
          className="appear-anim"
          icon={
            <ThemedAsset
              id={assetIds.ICON_LOAN_ADJUST}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId={"DATA_TREATMENT"} />}
          subtitle={<Text tId="INFORMATION_ABOUT_RISK_ANALYSIS" />}
        />
      </Box>
      <Box>
        <TermsAndConditionsContainer
          textId={"SUA_TERMS_AND_CONDITIONS"}
          onEndScroll={onEndScroll}
        />
      </Box>
      <Box>
        <OptinsManager
          optInsState={optInsState}
          handleChange={handleToggleChange}
          errors={errors}
          register={register}
          control={control}
        />
      </Box>
      <MainButton
        disabled={disabled || !isAtBottom}
        onClick={handleSubmit(() => handleRiskAnalysisOptIns())}
      >
        <Text tId="CONTINUE" />
      </MainButton>
    </>
  );
};
